import { KeycloakService } from "keycloak-angular";
import {AppConfig} from "@app-so/app.config";
import {AuthService, EnvironmentModel, ProfileService} from "@common/generic";
import {UsersApiService} from "@app-so/users/services/users-api.service";
import {User} from "@app-so/users/models/User";
import {StorageService} from "@generic/services/storage.service";
import {storageKeys} from "@app-so/constants";


export function initializeKeycloak(
  keycloak: KeycloakService,
  config: AppConfig,
  profile : ProfileService,
  storageService: StorageService,
): () => Promise<any> {
  const jsonFile = `assets/config.json`;
  //let profile : ProfileService;
  return (): Promise<any> => {
    return new Promise(  (resolve, reject) => {

      try {
        // @ts-ignore
        config.internalhttp.get(jsonFile).toPromise().then((response: EnvironmentModel) => {
          AppConfig.settings = response;
          //  resolve();
          keycloak.init({
            config: {
              url: AppConfig.settings.keycloakEndpoint,//'http://localhost:8080/auth',
              realm: AppConfig.settings.realmName,
              clientId: 'frontend',
            },
            initOptions: {
              onLoad: 'login-required',
              checkLoginIframe: false,
              responseMode: 'query',
              useNonce: false,
              //idToken: storageService.getItem(storageKeys.auth),
              //refreshToken: storageService.getItem(storageKeys.refreshToken),
            },
            loadUserProfileAtStartUp: false,
            //enableBearerInterceptor: true,
          }).then((isInitialize) => {
            console.log("keycloak is initialized : ", isInitialize);
            const keycloakInstance = keycloak.getKeycloakInstance();
            const username = keycloakInstance.idTokenParsed && keycloakInstance.idTokenParsed["preferred_username"];
            const token = keycloakInstance.token;
            const refreshToken = keycloakInstance.refreshToken;
            if (!username || !token) {
              const error = new Error("Keycloak did not return a username or access token");
              console.log("error happened during Keycloak initialization : ", JSON.stringify(error));
              storageService.removeItem(storageKeys.auth);
              storageService.removeItem(storageKeys.refreshToken);
              storageService.removeItem(storageKeys.authExpiration);
              keycloak.logout();
              reject(error);
              return;
            }
            const expiresAt = keycloakInstance.tokenParsed && keycloakInstance.tokenParsed["exp"]
              ? <any>keycloakInstance.tokenParsed["exp"] * 1000
              : Date.now();
            console.log("username : ", JSON.stringify(username));
            storageService.setItem(storageKeys.auth, token);
            storageService.setItem(storageKeys.refreshToken, refreshToken || "");
            storageService.setItem(storageKeys.authExpiration, JSON.stringify(expiresAt));
            config.internalhttp.get<User>(
              `${AppConfig.settings.apiEndpoint}/api/getUserById/${encodeURIComponent(username)}`,
              { headers: { Authorization: `Bearer ${token}` } }
            ).toPromise().then(
              userDetails => {
                profile.set({
                  email: userDetails.email,
                  partyId: userDetails.partyId,
                  partyName: userDetails.partyName,
                  role: userDetails.roles,
                  id: userDetails.email,
                  org: userDetails.org,
                  mode: userDetails.mode,
                  configPartyName: userDetails.configPartyName,
                  orgtype: userDetails.orgtype,
                });
                console.log('response', JSON.stringify(userDetails));
                resolve();
              }).catch(error => {
              console.log("error happened while getting user details  : ", JSON.stringify(error));
              storageService.removeItem(storageKeys.auth);
              storageService.removeItem(storageKeys.refreshToken);
              storageService.removeItem(storageKeys.authExpiration);
              keycloak.logout();
              reject(error);
            });
            //resolve();
            // resolve();
          }).catch(error => {
            console.log("error happened during Keycloak  : ", JSON.stringify(error));
            reject(error);
            // keycloak.logout();
          });
          // resolve();
        }).catch(reason => {
          console.log("error happened during Keycloak config : ", JSON.stringify(reason));
          reject(reason);
        });
        //getTokenresolve();
      } catch (error) {
        console.log("error happened during Keycloak initialization : ", JSON.stringify(error));
        reject(error);
      }
      // resolve();
    });
  };
}
